export default __webpack_public_path__ + "static/monikas-71903ce032ddda18828ab768c32a0d11.png";